import { $Q, $Qll } from "../utils/query-selector";

/**
   * Click on reviews and move scroll to widget reviews
   * 
   * @author Sebastián García <sebastian.garcia@gradiweb.com>
   */
export function onClickReviews() {
  const stampedBadge = $Q('.stamped-badge');
  const stampedWidget = $Q(".stamped-reviews-h2");
  const body = $Q("body");

  if (stampedBadge && stampedWidget) {
    stampedBadge.addEventListener('click', () => {
      const newPosScroll = stampedWidget.offsetTop - 150;
      window.scroll({ top: newPosScroll, behavior: 'smooth' }); 
    });
  }
}